import { render } from "./ScorecardsPerspectiveItem.vue?vue&type=template&id=60644d26&scoped=true&ts=true"
import script from "./ScorecardsPerspectiveItem.vue?vue&type=script&lang=ts"
export * from "./ScorecardsPerspectiveItem.vue?vue&type=script&lang=ts"

import "./ScorecardsPerspectiveItem.vue?vue&type=style&index=0&id=60644d26&lang=scss"
import "./ScorecardsPerspectiveItem.vue?vue&type=style&index=1&id=60644d26&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60644d26"]])

export default __exports__